webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(105);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(98);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(94)
	
	var Component = __webpack_require__(11)(
	  /* script */
	  __webpack_require__(43),
	  /* template */
	  __webpack_require__(104),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(55);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.default = function (content) {
	  var _content$split = content.split('---'),
	      _content$split2 = (0, _slicedToArray3.default)(_content$split, 2),
	      _content$split2$ = _content$split2[0],
	      candidates = _content$split2$ === undefined ? '' : _content$split2$,
	      _content$split2$2 = _content$split2[1],
	      rounds = _content$split2$2 === undefined ? '' : _content$split2$2;
	
	  return {
	    candidates: candidates.split('\n').map(function (line) {
	      return line.trim();
	    }).filter(function (line) {
	      return line;
	    }).map(function (line) {
	      var _line$split = line.split('|'),
	          _line$split2 = (0, _slicedToArray3.default)(_line$split, 2),
	          name = _line$split2[0],
	          desc = _line$split2[1];
	
	      return {
	        name: name,
	        desc: desc
	      };
	    }),
	    rounds: rounds.split('\n').map(function (line) {
	      return line.trim();
	    }).filter(function (line) {
	      return line;
	    }).map(function (line) {
	      var _line$split3 = line.split('|'),
	          _line$split4 = (0, _slicedToArray3.default)(_line$split3, 2),
	          title = _line$split4[0],
	          count = _line$split4[1];
	
	      var normalizedCount = parseInt(count, 10);
	      return {
	        title: title,
	        count: normalizedCount
	      };
	    })
	  };
	};
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.focus = focus;
	exports.fitByFontSize = fitByFontSize;
	function focus(el, isCollapse) {
	  if (!el) {
	    return;
	  }
	  var range = document.createRange();
	  var selection = window.getSelection();
	  if (typeof el.select === 'function' && el.value !== undefined) {
	    el.select();
	    if (isCollapse) {
	      selection.collapseToEnd();
	    }
	  } else if (el.contentEditable === 'true') {
	    range.selectNodeContents(el);
	    if (isCollapse) {
	      range.collapse();
	    }
	    selection.removeAllRanges();
	    selection.addRange(range);
	    el.focus();
	  } else {
	    el.focus();
	  }
	}
	
	function fitByFontSize(el) {
	  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
	  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
	
	  while (el.scrollHeight > el.offsetHeight) {
	    if (!adjustFontSize(el, min, -step)) {
	      break;
	    }
	  }
	}
	
	function adjustFontSize(el, min, amount) {
	  var size = Math.max(parseInt(window.getComputedStyle(el).fontSize, 10) + amount, min);
	  if (size !== min) {
	    el.style.fontSize = size + 'px';
	    return true;
	  }
	  return false;
	}

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(52);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.save = save;
	exports.load = load;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function save(key, value) {
	  if (typeof key === 'string') {
	    localStorage.setItem(key, (0, _stringify2.default)(value));
	  } else {
	    for (var k in key) {
	      if (key.hasOwnProperty(k)) {
	        localStorage.setItem(k, (0, _stringify2.default)(key[k]));
	      }
	    }
	  }
	}
	
	function load(key, defaultValue) {
	  var value = null;
	  if (typeof key === 'string') {
	    value = localStorage.getItem(key);
	  }
	  try {
	    value = value === null && defaultValue !== undefined ? defaultValue : JSON.parse(value);
	  } catch (e) {
	    value = defaultValue !== undefined ? defaultValue : null;
	  }
	  return value;
	}

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(56);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _log = __webpack_require__(53);
	
	var _log2 = _interopRequireDefault(_log);
	
	exports.pad = pad;
	exports.swap = swap;
	exports.shuffle = shuffle;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function pad(number, digits) {
	  var numDigits = Math.floor((0, _log2.default)(number)) + 1;
	  if (numDigits >= digits) {
	    return '' + number;
	  }
	  return Array(digits - numDigits).fill(0).join('') + number;
	}
	
	function swap(items, i, j) {
	  var k = items[i];
	  items[i] = items[j];
	  items[j] = k;
	}
	
	function shuffle(items) {
	  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : items.length;
	
	  count = Math.min(items.length, count);
	  var shuffled = [].concat((0, _toConsumableArray3.default)(items));
	  var len = shuffled.length;
	  for (var i = 0; i < count; i++) {
	    var j = Math.floor(Math.random() * (len - i)) + i;
	    swap(shuffled, i, j);
	  }
	  return shuffled;
	}

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(49);
	
	var icons = {};
	
	exports.default = {
	  name: 'octicon',
	  props: {
	    name: {
	      type: String,
	      validator: function validator(val) {
	        if (val) {
	          return val in icons;
	        }
	        return null;
	      }
	    },
	    scale: [Number, String],
	    spin: Boolean,
	    inverse: Boolean,
	    flip: {
	      validator: function validator(val) {
	        return val === 'horizontal' || val === 'vertical';
	      }
	    },
	    label: String
	  },
	  data: function data() {
	    return {
	      x: false,
	      y: false,
	      childrenWidth: 0,
	      childrenHeight: 0,
	      outerScale: 1
	    };
	  },
	
	  computed: {
	    normalizedScale: function normalizedScale() {
	      var scale = this.scale;
	      scale = typeof scale === 'undefined' ? 1 : Number(scale);
	      if (isNaN(scale) || scale <= 0) {
	        (0, _util.warn)('Invalid prop: prop "scale" should be a number over 0.', this);
	        return this.outerScale;
	      }
	      return scale * this.outerScale;
	    },
	    clazz: function clazz() {
	      return {
	        'octicon': true,
	        'octicon-spin': this.spin,
	        'octicon-flip-horizontal': this.flip === 'horizontal',
	        'octicon-flip-vertical': this.flip === 'vertical',
	        'octicon-inverse': this.inverse
	      };
	    },
	    icon: function icon() {
	      if (this.name) {
	        return icons[this.name];
	      }
	      return null;
	    },
	    box: function box() {
	      if (this.icon) {
	        if (this.icon.viewBox) {
	          return this.icon.viewBox;
	        }
	        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
	      }
	      return '0 0 ' + this.width + ' ' + this.height;
	    },
	    width: function width() {
	      return this.childrenWidth || this.icon && this.icon.width * this.normalizedScale || 0;
	    },
	    height: function height() {
	      return this.childrenHeight || this.icon && this.icon.height * this.normalizedScale || 0;
	    },
	    style: function style() {
	      if (this.normalizedScale === 1) {
	        return false;
	      }
	      return {
	        fontSize: this.normalizedScale + 'em'
	      };
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (this.icon) {
	      return;
	    }
	    this.$children.forEach(function (child) {
	      child.outerScale = _this.normalizedScale;
	    });
	    var width = 0;
	    var height = 0;
	    this.$children.forEach(function (child) {
	      width = Math.max(width, child.width);
	      height = Math.max(height, child.height);
	    });
	    this.childrenWidth = width;
	    this.childrenHeight = height;
	    this.$children.forEach(function (child) {
	      child.x = (width - child.width) / 2;
	      child.y = (height - child.height) / 2;
	    });
	  },
	  register: function register(data) {
	    for (var name in data) {
	      icons[name] = data[name];
	    }
	  },
	
	  icons: icons
	};

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(23);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(54);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getIterator2 = __webpack_require__(22);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _utils = __webpack_require__(42);
	
	var _storage = __webpack_require__(41);
	
	var _dom = __webpack_require__(40);
	
	var _extract2 = __webpack_require__(39);
	
	var _extract3 = _interopRequireDefault(_extract2);
	
	var _File = __webpack_require__(99);
	
	var _File2 = _interopRequireDefault(_File);
	
	var _NameLabel = __webpack_require__(100);
	
	var _NameLabel2 = _interopRequireDefault(_NameLabel);
	
	var _Octicon = __webpack_require__(21);
	
	var _Octicon2 = _interopRequireDefault(_Octicon);
	
	__webpack_require__(48);
	
	__webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EMOJIS = ['👻', '🤟', '🖖', '🙈', '🎰', '🤩', '😜', '😎', '🤑', '🤘'];
	
	function split(str) {
	  var result = [];
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = (0, _getIterator3.default)(str), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var c = _step.value;
	
	      result.push(c);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return result;
	}
	
	function loadSettings() {
	  var cooldown = (0, _storage.load)('cooldown');
	  cooldown = cooldown == null ? 500 : cooldown;
	
	  var emojis = (0, _storage.load)('emojis') || EMOJIS.join('');
	  var emojiList = split(emojis);
	
	  var welcome = (0, _storage.load)('welcome') || emojiList[Math.floor(Math.random() * emojiList.length)];
	
	  var mode = (0, _storage.load)('mode') || 'both';
	
	  var custom = (0, _storage.load)('custom') || '';
	
	  return {
	    emojis: emojis, cooldown: cooldown, welcome: welcome, mode: mode, custom: custom
	  };
	}
	
	var INITIAL = (0, _extends3.default)({
	  candidates: [],
	  winners: [],
	  total: null,
	  round: null,
	  rolling: false,
	  isSetup: false,
	  isNumber: false,
	  isFit: true,
	  editing: false,
	  showLog: false,
	  logs: [],
	  showSettings: false,
	  rounds: [],
	  coolingDown: false
	}, loadSettings());
	
	exports.default = {
	  name: 'lucky',
	  components: {
	    File: _File2.default,
	    NameLabel: _NameLabel2.default,
	    Octicon: _Octicon2.default
	  },
	  data: function data() {
	    return (0, _extends3.default)({}, INITIAL);
	  },
	
	  computed: {
	    remaining: {
	      get: function get() {
	        if (!this.isSetup) {
	          return '∞';
	        }
	        return this.candidates.length;
	      }
	    }
	  },
	  methods: {
	    setup: function setup() {
	      if (!this.check('total')) {
	        return;
	      }
	
	      this.isNumber = true;
	      this.candidates = Array(this.total).fill(true).map(function (item, i) {
	        return { name: (0, _utils.pad)(i + 1, 3) };
	      });
	      this.isSetup = true;
	    },
	    log: function log(names) {
	      var rounds = (0, _storage.load)('current', []);
	      rounds.push(names);
	      (0, _storage.save)('current', rounds);
	    },
	    upload: function upload(_ref) {
	      var _this = this;
	
	      var target = _ref.target;
	
	      var file = target.files[0];
	      if (!file) {
	        return;
	      }
	      var reader = new FileReader();
	      reader.onload = function (_ref2) {
	        var target = _ref2.target;
	
	        var _extract = (0, _extract3.default)(target.result),
	            candidates = _extract.candidates;
	
	        _this.candidates = candidates;
	        _this.total = candidates.length;
	        _this.isSetup = true;
	        _this.focus('round');
	      };
	      reader.readAsText(file);
	    },
	    roll: function roll() {
	      var _this2 = this;
	
	      if (!this.check('round')) {
	        return;
	      }
	
	      var count = this.round;
	      if (!this.rolling) {
	        this.winners = [];
	        this.fit(true);
	        this.rolling = setInterval(function () {
	          _this2.shuffle(count);
	          _this2.fit();
	        }, 1000 / 15);
	        this.focus('begin');
	      } else {
	        this.candidates.splice(0, count);
	        clearTimeout(this.rolling);
	        this.rolling = false;
	        this.checkRemaining();
	        this.log(this.winners);
	      }
	
	      this.coolingDown = true;
	      setTimeout(function () {
	        _this2.coolingDown = false;
	      }, this.cooldown);
	    },
	    shuffle: function shuffle(count) {
	      var shuffled = (0, _utils.shuffle)(this.candidates, count);
	      this.winners = shuffled.slice(0, count);
	      this.candidates = shuffled;
	    },
	    reset: function reset() {
	      clearTimeout(this.rolling);
	      if (this.$refs.upload) {
	        this.$refs.upload.clear();
	      }
	      (0, _assign2.default)(this, (0, _extends3.default)({}, INITIAL, loadSettings()));
	    },
	    checkRemaining: function checkRemaining() {
	      var validity = '';
	      if (this.candidates.length < this.round) {
	        validity = '剩余人数不足' + this.round + '人。';
	      }
	      this.$refs.round.setCustomValidity(validity);
	    },
	    edit: function edit(isStart) {
	      this.editing = isStart;
	    },
	    click: function click(_ref3) {
	      var target = _ref3.target;
	
	      if (!this.$refs.welcome.contains(target)) {
	        this.edit(false);
	      }
	    },
	    focus: function focus(ref, isCollapse) {
	      var item = this.$refs[ref];
	      if (!item) {
	        return;
	      }
	      this.$nextTick(function () {
	        if (item instanceof HTMLElement) {
	          (0, _dom.focus)(item, isCollapse);
	        } else if (typeof item.focus === 'function') {
	          item.focus();
	        }
	      });
	    },
	    check: function check(ref) {
	      var message = this.$refs[ref].validationMessage;
	      if (message) {
	        alert(message);
	        return false;
	      }
	      return true;
	    },
	    fit: function fit(isReset) {
	      var _this3 = this;
	
	      var winners = this.$refs.winners;
	
	      if (isReset) {
	        this.isFit = false;
	        winners.style.fontSize = '';
	      } else {
	        this.$nextTick(function () {
	          (0, _dom.fitByFontSize)(winners);
	          _this3.isFit = true;
	        });
	      }
	    },
	    openLog: function openLog() {
	      this.logs = (0, _storage.load)('current');
	      this.showLog = true;
	    },
	    setStyles: function setStyles(val) {
	      if (!this.customStyleEl) {
	        var style = document.createElement('style');
	        style.innerHTML = val;
	        document.querySelector('head').appendChild(style);
	        this.customStyleEl = style;
	      } else {
	        this.customStyleEl.innerHTML = val;
	      }
	    }
	  },
	  watch: {
	    isSetup: function isSetup(val, oldVal) {
	      if (val !== oldVal) {
	        if (val) {
	          (0, _storage.save)('previous', (0, _storage.load)('current'));
	          (0, _storage.save)('current', []);
	        }
	        this.focus(val ? 'round' : 'total');
	      }
	    },
	    editing: function editing(val, oldVal) {
	      if (val !== oldVal) {
	        if (val) {
	          this.focus('welcome', true);
	        } else {
	          (0, _storage.save)('welcome', this.$refs.welcome.textContent);
	        }
	      }
	    },
	    emojis: function emojis(val) {
	      (0, _storage.save)('emojis', val);
	    },
	    cooldown: function cooldown(val) {
	      (0, _storage.save)('cooldown', val);
	    },
	    mode: function mode(val) {
	      (0, _storage.save)('mode', val);
	    },
	    custom: function custom(val) {
	      (0, _storage.save)('custom', val);
	      this.setStyles(val);
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    var customStyles = (0, _storage.load)('custom');
	    if (customStyles) {
	      this.setStyles(customStyles);
	    }
	
	    window.addEventListener('resize', function () {
	      if (_this4.isSetup) {
	        _this4.fit();
	      }
	    });
	    window.addEventListener('beforeunload', function () {
	      if (_this4.isSetup) {
	        return '目前抽奖尚未结束，是否要离开？';
	      }
	    });
	  }
	};

/***/ }),

/***/ 45:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'file',
	  props: {
	    name: String,
	    disabled: Boolean,
	    accept: String,
	    multiple: Boolean,
	    required: Boolean
	  },
	  methods: {
	    input: function input(e) {
	      this.$emit('input', e);
	    },
	    change: function change(e) {
	      this.$emit('change', e);
	    },
	    choose: function choose() {
	      this.$refs.file.click();
	    },
	    clear: function clear() {
	      this.$refs.file.value = '';
	    }
	  }
	};

/***/ }),

/***/ 46:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'name-label',
	  props: {
	    name: {
	      type: String,
	      required: true
	    },
	    desc: String
	  }
	};

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 94:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(92)
	
	var Component = __webpack_require__(11)(
	  /* script */
	  __webpack_require__(44),
	  /* template */
	  __webpack_require__(101),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(93)
	
	var Component = __webpack_require__(11)(
	  /* script */
	  __webpack_require__(45),
	  /* template */
	  __webpack_require__(102),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(11)(
	  /* script */
	  __webpack_require__(46),
	  /* template */
	  __webpack_require__(103),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 101:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      started: _vm.isSetup,
	        fit: _vm.isFit,
	        number: _vm.isNumber
	    },
	    attrs: {
	      "id": "app"
	    },
	    on: {
	      "click": _vm.click
	    }
	  }, [_c('div', {
	    ref: "stage",
	    attrs: {
	      "id": "stage"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "display"
	    }
	  }, [_c('div', {
	    ref: "winners",
	    attrs: {
	      "id": "winners"
	    }
	  }, _vm._l((_vm.winners), function(winner, i) {
	    return _c('name-label', {
	      key: i,
	      attrs: {
	        "name": winner.name,
	        "desc": winner.desc
	      }
	    })
	  }), 1), _vm._v(" "), _c('h1', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.winners.length && _vm.isFit),
	      expression: "!winners.length && isFit"
	    }],
	    ref: "welcome",
	    attrs: {
	      "id": "welcome",
	      "contenteditable": _vm.editing,
	      "spellcheck": "false"
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.welcome)
	    },
	    on: {
	      "dblclick": function($event) {
	        $event.stopPropagation();
	        return _vm.edit(true)
	      },
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.edit(false)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "control"
	    }
	  }, [_c('form', {
	    attrs: {
	      "id": "setup"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.setup($event)
	      }
	    }
	  }, [(_vm.mode !== 'number') ? _c('label', [_c('file', {
	    ref: "upload",
	    attrs: {
	      "disabled": _vm.isSetup
	    },
	    on: {
	      "change": _vm.upload
	    }
	  }, [_vm._v("选择文件")])], 1) : _vm._e(), _vm._v(" "), (_vm.mode === 'both') ? _c('span', {
	    staticClass: "separator"
	  }, [_vm._v("- or -")]) : _vm._e(), _vm._v(" "), (_vm.mode !== 'import') ? _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.total),
	      expression: "total",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "total",
	    attrs: {
	      "type": "number",
	      "required": "",
	      "min": "1",
	      "max": "999",
	      "disabled": _vm.isSetup,
	      "placeholder": "一共有几人？"
	    },
	    domProps: {
	      "value": (_vm.total)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.total = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.mode !== 'import') ? _c('button', {
	    attrs: {
	      "disabled": _vm.isSetup
	    }
	  }, [_vm._v("确定")]) : _vm._e()]), _vm._v(" "), _c('form', {
	    attrs: {
	      "id": "roll"
	    },
	    on: {
	      "reset": _vm.reset,
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.roll($event)
	      }
	    }
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.round),
	      expression: "round",
	      modifiers: {
	        "number": true
	      }
	    }],
	    ref: "round",
	    attrs: {
	      "type": "number",
	      "required": "",
	      "disabled": !_vm.isSetup || _vm.rolling,
	      "min": "1",
	      "max": _vm.remaining || 50,
	      "placeholder": "本轮抽几人？"
	    },
	    domProps: {
	      "value": (_vm.round)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.round = _vm._n($event.target.value)
	      }, _vm.checkRemaining],
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  })]), _vm._v("\n        /\n        "), _c('span', {
	    staticClass: "remaining"
	  }, [_vm._v(_vm._s(_vm.remaining))]), _vm._v(" "), _c('button', {
	    ref: "begin",
	    attrs: {
	      "disabled": !_vm.isSetup || _vm.coolingDown,
	      "name": "begin"
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.rolling ? '停止' : '开始') + "\n          "), (_vm.coolingDown) ? _c('span', {
	    staticClass: "cooler",
	    style: (("animation-duration: " + _vm.cooldown + "ms;"))
	  }) : _vm._e()]), _vm._v(" "), _c('button', {
	    attrs: {
	      "type": "reset",
	      "disabled": !_vm.isSetup || _vm.coolingDown
	    }
	  }, [_vm._v("\n          重置\n          "), (_vm.coolingDown) ? _c('span', {
	    staticClass: "cooler",
	    style: (("animation-duration: " + _vm.cooldown + "ms;"))
	  }) : _vm._e()]), _vm._v(" "), _c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.openLog
	    }
	  }, [_vm._v("记录")])])])]), _vm._v(" "), _c('div', {
	    class: {
	      show: _vm.showLog, modal: true
	    },
	    attrs: {
	      "id": "log",
	      "tabindex": "-1"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showLog = false
	      },
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	        _vm.showSettings = false
	      }
	    }
	  }, [_c('h2', [_vm._v("抽取历史")]), _vm._v(" "), (_vm.logs.length) ? _c('ol', _vm._l((_vm.logs), function(log, i) {
	    return _c('li', {
	      key: i
	    }, _vm._l((log), function(winner, j) {
	      return _c('name-label', {
	        key: j,
	        attrs: {
	          "name": winner.name,
	          "desc": winner.desc
	        }
	      })
	    }), 1)
	  }), 0) : _vm._e(), _vm._v(" "), (!_vm.logs.length) ? _c('h2', {
	    staticClass: "empty"
	  }, [_vm._v("还没有进行过抽奖")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    class: {
	      show: _vm.showSettings, modal: true
	    },
	    attrs: {
	      "id": "settings",
	      "tabindex": "-1"
	    },
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        _vm.showSettings = false
	      },
	      "keydown": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	        _vm.showSettings = false
	      }
	    }
	  }, [_c('h2', [_vm._v("设置")]), _vm._v(" "), _c('form', [_c('p', [_c('label', [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("间隔时间")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.cooldown),
	      expression: "cooldown",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "number"
	    },
	    domProps: {
	      "value": (_vm.cooldown)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.cooldown = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        return _vm.$forceUpdate()
	      }
	    }
	  }), _c('span', {
	    staticClass: "tip"
	  }, [_vm._v("毫秒")])])]), _vm._v(" "), _c('p', [_c('label', [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("表情")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.emojis),
	      expression: "emojis"
	    }],
	    staticClass: "hero",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.emojis)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.emojis = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('p', [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("输入模式")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mode),
	      expression: "mode"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "import"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.mode, "import")
	    },
	    on: {
	      "change": function($event) {
	        _vm.mode = "import"
	      }
	    }
	  }), _c('span', [_vm._v("文件导入")])]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mode),
	      expression: "mode"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "number"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.mode, "number")
	    },
	    on: {
	      "change": function($event) {
	        _vm.mode = "number"
	      }
	    }
	  }), _c('span', [_vm._v("抽取序号")])]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mode),
	      expression: "mode"
	    }],
	    attrs: {
	      "type": "radio",
	      "value": "both"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.mode, "both")
	    },
	    on: {
	      "change": function($event) {
	        _vm.mode = "both"
	      }
	    }
	  }), _c('span', [_vm._v("自由选择")])])]), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "custom"
	    }
	  }, [_c('label', [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("自定义样式")]), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.custom),
	      expression: "custom"
	    }],
	    attrs: {
	      "spellcheck": "false",
	      "rows": "10"
	    },
	    domProps: {
	      "value": (_vm.custom)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.custom = $event.target.value
	      }
	    }
	  })])])])]), _vm._v(" "), _c('button', {
	    attrs: {
	      "id": "setting"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showSettings = !_vm.showSettings
	      }
	    }
	  }, [_c('octicon', {
	    attrs: {
	      "name": "gear"
	    }
	  })], 1), _vm._v(" "), _c('a', {
	    attrs: {
	      "id": "github",
	      "href": "https://github.com/Justineo/lucky"
	    }
	  }, [_c('octicon', {
	    attrs: {
	      "name": "mark-github",
	      "label": "View on GitHub",
	      "title": "View on GitHub"
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),

/***/ 102:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "file"
	  }, [_c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.choose
	    }
	  }, [_vm._t("default", [_vm._v("选择文件")])], 2), _vm._v(" "), _c('input', {
	    ref: "file",
	    attrs: {
	      "type": "file",
	      "name": _vm.name,
	      "disabled": _vm.disabled,
	      "accept": _vm.accept,
	      "multiple": _vm.multiple,
	      "required": _vm.required
	    },
	    on: {
	      "input": _vm.input,
	      "change": _vm.change
	    }
	  })])
	},staticRenderFns: []}

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "name"
	  }, [_vm._v(_vm._s(_vm.name) + " "), (_vm.desc) ? _c('span', {
	    staticClass: "desc"
	  }, [_vm._v("(" + _vm._s(_vm.desc) + ")")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('svg', {
	    class: _vm.clazz,
	    style: (_vm.style),
	    attrs: {
	      "version": "1.1",
	      "role": _vm.label ? 'img' : 'presentation',
	      "aria-label": _vm.label,
	      "x": _vm.x,
	      "y": _vm.y,
	      "width": _vm.width,
	      "height": _vm.height,
	      "viewBox": _vm.box
	    }
	  }, [_vm._t("default", [(_vm.icon) ? _c('path', {
	    attrs: {
	      "d": _vm.icon.d
	    }
	  }) : _vm._e()])], 2)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.cf60c77bc80b04fae97e.js